import http from './http'



//登录
export const onLogin = data => {
    return http({ method: 'post', url: '/auth/login', data })
}

//根据token获取用户信息
export const getInfo = () => {
    return http({ method: 'get', url: '/auth/getInfo' })
}

//根据token获取菜单树
export const getRouters = () => {
    return http({ method: 'get', url: '/auth/getRouters' })
}

//个人中心-修改个人密码
export const updatePwd = data => {
    return http({ method: 'put', url: '/auth/system/user/profile/updatePwd', data })
}
